import React, { Component } from 'react';
import { Link } from 'react-router'

import {} from './Footer.css';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    openMailto() {
        window.location.href='mailto:info@g-c3n4.com?subject=Web Site Enquiry&body=Hi g-C3N4 team,';
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="Footer-container">
                    <Link className="Home-link" to="/">
                        <div className="Footer-panel Right">
                            <p className="Footer-title">g-C3N4</p>
                        </div>
                    </Link>
                    <div className="Footer-panel Left">
                        <img className="Footer-logo" src="/logo_w.png" alt="g-C3N4" />
                    </div>
                    <div className="Footer-panel Left">
                        <ul className="Footer-sitelinks">
                            <li className="Footer-sitelink"><Link to="/news"> News </Link></li>
                            <li className="Footer-sitelink"><Link to="/technical"> General Information</Link></li>
                            <li className="Footer-sitelink"><Link to="/research"> Research </Link></li>
                        </ul>
                    </div>
                    <div className="Footer-panel Left">
                        <ul className="Footer-sitelinks">
                            <li className="Footer-sitelink"><Link to="/opensource"> Open Source </Link></li>
                            <li className="Footer-sitelink"><Link to="/p/1"> Blog </Link></li>
                            <li className="Footer-sitelink"><Link to="/about"> About </Link></li>
                        </ul>
                    </div>
                    <div className="Footer-panel Left">
                        <ul className="Footer-sitelinks">
                            <li className="Footer-sitelink">Contact</li>
                            <li className="Footer-sitelink">&nbsp;</li>
                            <li className="Footer-sitelink Pointer" onClick={this.openMailto}>info [at] g-C3N4.com</li>
                        </ul>
                    </div>
                    
                    
                    
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js